import React from "react";

import withStyles from '@mui/styles/withStyles';
import classnames from "classnames";

import { BookingOrderStatuses } from "../../../Booking/Maintenance/Orders/types";

type Props = {
  value?: string;
  backgroundColor?: string;
  textColor?: string;
  classes?: any;
  className?: string;
};

const styles = () =>
  ({
    container: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    customBadge: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
        props?.backgroundColor,
      width: "108px",
      height: "32px",
      borderRadius: "20px",
    },
    textValue: {
      color: (props: { textColor?: string }) => props?.textColor,
      fontFamily: "Inter",
      fontSize: "10px",
      fontWeight: 600,
      lineHeight: "20px",
      whiteSpace: "nowrap",
    },
  } as const);

interface BookingOrderStatusProps {
  value: string;
  className?: string;
}

const SimpleBadge = (props: Props) => {
  const { classes, value, className } = props;

  return (
    <div className={classnames(classes.container, className)}>
      <div className={classes.customBadge}>
        <span className={classes.textValue}>{value}</span>
      </div>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

export const ShipmentOrderStatus: React.FC<BookingOrderStatusProps> = ({ value, className }) => {
  if (!value) return null;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          className={className}
        />
      );

    return <> </>;
  };

  switch (value) {
    case BookingOrderStatuses.READY:
      return renderBadge("#D1E9FF", "#2E90FA", BookingOrderStatuses.READY);
    case BookingOrderStatuses.ADDED:
      return renderBadge("#D1FADF", "#32D583", BookingOrderStatuses.ADDED);
    default:
      return null;
  }
};
